import { Box } from "@chakra-ui/react"
import { Outlet } from "react-router-dom"

import { Center, Container, Flex } from "@chakra-ui/react"

const AuthLayout: React.FC = () => {
  return (
    <Container maxW="100%" h="100vh" p={0}>
      <Flex flexDirection={{ base: "column", lg: "row" }} h="100vh">
        {/* Form Section - Left side on desktop, full width on mobile */}
        <Box
          w={{ base: "100%", lg: "50%" }}
          minW={{ base: "auto", lg: "320px" }}
          bg=""
          h={{ base: "100%", lg: "100%" }}
          order={{ base: 2, lg: 1 }}
          overflowY={"auto"}
        >
          <Flex
            px={{ base: 4, md: 8, lg: 20 }}
            py={{ base: 8, lg: 0 }}
            flexDirection={"column"}
            gap={4}
            alignItems={"center"}
            minH={{ base: "calc(100vh - 200px)", lg: "100%" }}
            justifyContent={"center"}
          >
            <Outlet />
          </Flex>
        </Box>

        {/* Image Banner - Right side on desktop, top on mobile */}
        <Box
          w={{ base: "100%", lg: "50%" }}
          h={{ base: "200px", lg: "100%" }}
          backgroundImage="linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25)), url('/images/futurehomes2.jpg')"
          backgroundSize="cover"
          backgroundPosition={{ base: "top", lg: "left" }}
          backgroundRepeat="no-repeat"
          order={{ base: 1, lg: 2 }}
        />
      </Flex>
    </Container>
  )
}

export default AuthLayout
